<template>
    <kgr-form-scaffold
        :pending="pending"
        :with-delete-button="true"
        edit-mode
        @primaryBtnClicked="addField"
        @backBtnClicked="redirectToOverview"
        @deleteBtnClicked="deleteField"
    >
        <kgr-field-basic-data-provider
            :field-id="fieldId"
            :area-id="areaId"
            :location-id="locationId"
            :callback="onFieldLoaded"
        >
            <kgr-field-create-form
                :field="field"
                :error="error"
                @enter="addField"
            />
        </kgr-field-basic-data-provider>
    </kgr-form-scaffold>
</template>

<script>

import Area from '../../js/dto/resource/Area';
import Error from '../../js/model/Error';
import Field from '../../js/dto/resource/Field';
import FieldBasicDataForm from '../../components/resource/FieldBasicDataForm';
import FieldBasicDataProvider from '../../components/data-provider/FieldDataProvider';
import FieldRepository from '../../js/repository/FieldRepository';
import FormScaffold from '../../components/common/form/FormScaffold';
import Location from '../../js/dto/resource/Location';

export default {
    components: {
        'kgr-field-basic-data-provider': FieldBasicDataProvider,
        'kgr-field-create-form': FieldBasicDataForm,
        'kgr-form-scaffold': FormScaffold,
    },
    props: {
        fieldId: {
            type: String,
            required: true,
        },
        areaId: {
            type: String,
            required: true,
        },
        locationId: {
            type: String,
            required: true,
        },
        overviewUrl: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            pending: false,
            field: new Field(),
            area: new Area(),
            location: new Location(),
            error: new Error()
        };
    },
    methods: {
        redirectToOverview() {
            window.location = this.overviewUrl;
        },
        onFieldLoaded(loadedField) {
            this.field = loadedField;
        },
        addField() {
            if (this.pending) {
                return;
            }

            this.pending = true;

            FieldRepository.update(this.field,  this.areaId, this.locationId)
                .then(() => {
                    this.$notify.success('field.update', {}, { saveInSession: true });
                    window.location = `/backend/resources/locations/${this.locationId}/areas/${this.areaId}/fields/${this.field.id}/edit`;
                })
                .catch(error => {
                    this.handleError(error);
                    this.pending = false;
                });
        },
        deleteField() {
            if (this.field.isDeletable) {
                showConfirm(this.$t('confirm'), this.$t('field.delete.confirm', {}), () => {
                    this.pendingRemove = true;
                    FieldRepository.delete(this.locationId, this.areaId, this.fieldId)
                        .then(() => {
                            this.$notify.success('field.delete.success');
                            this.pendingRemove = false;
                            this.redirectToOverview();
                        })
                        .catch(() => {
                            this.$notify.error('field.delete.error');
                            this.pending = false;
                        }
                        );
                }, 'Ok');
            }
            else {
                showConfirm(this.$t('confirm'), this.$t('field.archive.confirm', {}), () => {
                    this.pendingRemove = true;
                    FieldRepository.archive(this.locationId, this.areaId, this.fieldId)
                        .then(() => {
                            this.$notify.success('field.archive.success');
                            this.pendingRemove = false;
                            this.redirectToOverview();
                        })
                        .catch(() => {
                            this.$notify.error('field.archive.error');
                            this.pending = false;
                        }
                        );
                }, 'Ok');
            }

        },
        handleError(error) {
            this.error = error;
            this.$notify.error('saveChanges.error');
        },
    },
}



</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
